<template>
  <div :class="{ content: fromPage == 'apply', vipcontent: fromPage == 'vip' }">
    <div class="bodycontent" v-loading="loading">
      <!-- 头部菜单 -->
      <div class="option">
        <div class="left">
          <el-button icon="el-icon-plus" type="primary" @click="addStore()"
            >添加门店</el-button
          >
        </div>
        <div class="right">
          <span>
            <el-input
              type="text"
              placeholder="门店名称"
              v-model="keyword"
              style="width:180px"
              clearable
            />
          </span>
          <span>
            <el-button type="primary" @click="search()">搜索</el-button>
          </span>
        </div>
      </div>
      <!-- 开卡记录列表 -->
      <el-table :data="listData" height="100%">
        <el-table-column label="门店名称" prop="name"></el-table-column>
        <!-- <el-table-column label="店铺名称" prop="store_name"></el-table-column> -->
        <el-table-column label="门店地址" prop="show_address"></el-table-column>
        <el-table-column label="联系电话" prop="mobile"></el-table-column>
        <!-- <el-table-column label="营业时间" prop="show_time"></el-table-column> -->
        <!-- <el-table-column label="同城配送点"></el-table-column> -->
        <el-table-column
          label="上门自提点"
          prop="show_service"
        ></el-table-column>
        <!-- <el-table-column label="是否停业" prop="show_rest"></el-table-column> -->
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="120px"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row.id)"
              >编辑</el-button
            >
            <el-button type="text" @click="delItem(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <Judge
      :show="showJudge"
      :judgeText="judgeText"
      :judgeButton="judgeButton"
      :judgeClose="true"
      @gotoNext="gotoNext()"
      @close="showJudge = false"
    ></Judge>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { storeList, storeDelete, allStore } from "@/api/storeManage";
import Judge from "@/components/vip/judgeDialog";
export default {
  props: {
    fromPage: {
      type: String,
      default: "apply"
    }
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    Judge
  },
  data() {
    return {
      listData: [], //列表
      keyword: "", //关键字筛选
      page: 1,
      total: 0,
      multi: false, //是否是多商户
      loading: false, //页面loading
      showJudge: false, //第一次创建门店成功提醒
      judgeText: "创建门店成功，您还未创建会员卡，请前往创建",
      judgeButton: "去创建会员卡"
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      allStore({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.multi = true;
        } else if (res.code == 400) {
          this.multi = false;
        } else {
          this.$message(res.msg);
        }
        this.getData();
        this.loading = false;
      });
    },
    getData() {
      this.loading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        name: this.keyword
      };
      storeList(data).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.listData = res.data;
          this.listData.forEach(item => {
            item.show_address = item.area.split(" ").join("") + item.address;
            item.show_time = item.start_time + "~" + item.end_time;
            item.show_service =
              item.service == 1 || item.service == 3 ? "是" : "否";
            item.show_rest = item.rest == 1 ? "是" : "否";
          });
          this.total = res.total;
          this.judge();
        } else if (res.code == 400) {
          this.listData = res.data;
          this.$message(res.msg);
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
        this.loading = false;
      });
    },
    judge() {
      var n = sessionStorage.getItem("newName");
      console.log(this.listData);
      if (this.listData.length == 1 && this.listData[0].name == n) {
        this.showJudge = true;
        sessionStorage.removeItem("newName");
      }
    },
    gotoNext() {
      this.$router.push("/apply/newVip/13/card/vip");
    },
    search() {
      this.page = 1;
      this.getData();
    },
    //跳页
    handleCurrentChange(p) {
      this.page = p;
      this.getData();
    },
    //编辑
    editItem(id) {
      this.$router.push({ path: "addStore", query: { sid: id } });
    },
    //新增
    addStore() {
      this.$router.push({ path: "addStore" });
    },
    //删除
    delItem(i) {
      this.$confirm(
        "删除门店后可能导致员工、收款码等功能无法正常使用，如需修改请点击编辑操作",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          var data = {
            token:this.token,
            app_id:this.app_id,
            id:i
          }
          storeDelete(data).then(res=>{
            if(res.code == 200){
              this.$message({
                type:"success",
                message:"删除成功"
              })
              this.getData()
            }else{
              this.$message({
                type:"error",
                message: res.msg
              })
            }
          })
        })
        .catch();
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    .option {
      height: 79px;
      line-height: 79px;
      display: flex;
      .left {
        flex: 1;
      }
      .right {
        text-align: right;
        span {
          margin-left: 30px;
          .el-select {
            width: 150px;
          }
        }
      }
    }
    // table
    .el-table {
      flex: 1;
      box-shadow: 0 0 3px #f1f1f1;
      padding-left: 10px;
    }
    .level_img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
    }
    //表格中的商品内容
    .table_line {
      height: 20px;
      line-height: 20px;
      white-space: space wrap;
    }
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      line-height: 34px;
    }
  }
}
.vipcontent {
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  position: relative;
  .option {
    height: 79px;
    line-height: 79px;
    display: flex;
    .left {
      flex: 1;
    }
    .right {
      text-align: right;
      span {
        margin-left: 30px;
        .el-select {
          width: 150px;
        }
      }
    }
  }
  // table
  .el-table {
    flex: 1;
    box-shadow: 0 0 3px #f1f1f1;
    padding-left: 10px;
  }
  .level_img {
    width: 40px;
    height: 40px;
    border-radius: 20px;
  }
  //表格中的商品内容
  .table_line {
    height: 20px;
    line-height: 20px;
    white-space: space wrap;
  }
  //分页
  .Otherpage {
    height: 34px;
    width: 200px;
    line-height: 34px;
  }
}
</style>
